<script>import { melt } from "@melt-ui/svelte";
import { ctx } from "../ctx.js";
export let sideOffset = 5;
export let transition = void 0;
export let transitionConfig = void 0;
export let asChild = false;
const {
  elements: { menu },
  states: { open }
} = ctx.getContent(sideOffset);
</script>

<!-- svelte-ignore a11y-no-static-element-interactions applied by melt's action/store -->
{#if $open}
	{@const builder = $menu}
	{#if asChild}
		<slot {builder} />
	{:else if transition}
		<div {...builder} use:builder.action {...$$restProps} on:m-keydown transition:transition={transitionConfig}>
			<slot {builder} />
		</div>
	{:else}
		<div {...builder} use:builder.action {...$$restProps} on:m-keydown>
			<slot {builder} />
		</div>
	{/if}
{/if}
